export default __webpack_public_path__ + "static/soniincorporation_service-9f216a4092ca33a37d2090d501c65ede.png";